import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import { FiMenu, FiSidebar } from "react-icons/fi";
import Sidebar from "../Sidebar";

function AppLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleMobileSidebar = () => {
    document.body.classList.toggle("main");
  };

  return (
    <div
      className={`main_dashboard_block app-shell ${
        isCollapsed ? "sidebar-collapsed" : ""
      }`}
    >
      <div className="top_navbar">
        <Navbar collapseOnSelect fixed="top" expand="xl" variant="light">
          <Navbar.Brand className="px-4" href="/">
            <img src="/images/logo.svg" alt="Uno admin" />
          </Navbar.Brand>
          <Navbar.Toggle
            onClick={toggleMobileSidebar}
            className="mx-4"
            aria-controls="responsive-navbar-nav"
          />
        </Navbar>
      </div>

      <div className="dashboard_wrapper">
        <aside className="dashboardsidebar">
          <Sidebar isCollapsed={isCollapsed} />
        </aside>

        <main className="app-outlet">
          {/* <button
            type="button"
            className="sidebar-collapse-btn"
            onClick={() => setIsCollapsed((current) => !current)}
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isCollapsed ? <FiMenu size={18} /> : <FiSidebar size={18} />}
          </button> */}
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
